module.exports = __webpack_public_path__ + "img/g_and_f_mid.b4f3dfb3.png";